import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=0a583632&scoped=true"
import script from "./FooterBlock.vue?vue&type=script&lang=ts"
export * from "./FooterBlock.vue?vue&type=script&lang=ts"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&id=0a583632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a583632",
  null
  
)

export default component.exports